import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { SheetData1 } from '../../../services/auth-service/authService'

import Select, { components } from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';

import {GetProcessNames, SaveRelationship, Fetchusersdata} from '../../../services/demo/process_data';

import './relationship.css';


const identifier = [
  { value: "string", label: "string" },
  { value: "int", label: "int" },
  { value: "special charectors", label: "special charectors" },
  { value: "contains", label: "contains" },
  { value: "starts with", label: "starts with" },
  { value: "ends with", label: "ends with" },

];

const identifier1 = [
  { value: "read", label: "read" },
  { value: "send", label: "send" },
  { value: "both", label: "both" },

];

const identifier2 = [
    { value: "from mail", label: "from mail" },
    { value: "subject", label: "subject" },
    { value: "body", label: "body" },
  
  ];

  const id1 = [
    { value: "domain name", label: "domain name" },
    { value: "mail id", label: "mail id" },
    { value: "string", label: "string" },
  ];

  const id2 = [
    { value: "string", label: "string" },
    { value: "date", label: "date" },
  ];

  const id3 = [
    { value: "string", label: "string" },
  ];


const ValueContainer = ({ children, getValue, ...props }) => {
  let maxToShow = 1;
  var length = getValue().length;
  let displayChips = React.Children.toArray(children).slice(0, maxToShow);
  let shouldBadgeShow = length > maxToShow;
  let displayLength = length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && displayChips}
      <div className="root">
        {/* {shouldBadgeShow &&
          `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
      </div>
    </components.ValueContainer>
  );
};





const NewMail = () => {
    const [show, setShow] = useState(true);
    const [show1, setShow1] = useState(true);

  const [relationshipName, setRelationshipName] = useState('');
  const [description, setDescription] = useState('');
  const [description1, setDescription1] = useState('');
  const [description2, setDescription2] = useState('');
  const [process, setProcess] = useState({});
  const [relationshipType, setRelationshipType] = useState({});
  const [targetNames, setSelectedOptions] = useState([]);

  const [identifierNames, setidentifierNames] = useState([]);

  const [selectedprocess1, setSelectedprocess1] = useState([]);

  const [newporequirment, setNewporequirment] = useState({
    signal: '',
    identifier: '',
    value: '',
    
});

  // Create state variable for the Select component's value
  const [selectedSource, setSelectedSource] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));

  const [porequirmentDetails, setPorequirmentDetails] = useState([]);

  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
};

const handleMaterialNameQuotationChange = (e, index) => {
    const updatedPorequirmentquotationDetails = [...porequirmentDetails];
    updatedPorequirmentquotationDetails[index].value = e.target.value;
    setPorequirmentDetails(updatedPorequirmentquotationDetails);
};

const handleMaterialNameQuotationChange1 = (e, index) => {
    const updatedPorequirmentquotationDetails = [...porequirmentDetails];
    updatedPorequirmentquotationDetails[index].identifier = e;
    setPorequirmentDetails(updatedPorequirmentquotationDetails);
};

const handleMaterialNameQuotationChange2 = (e, index) => {
    const updatedPorequirmentquotationDetails = [...porequirmentDetails];
    updatedPorequirmentquotationDetails[index].signal = e;
    setPorequirmentDetails(updatedPorequirmentquotationDetails);
};

const addFieldValue = () => {
    setPorequirmentDetails([...porequirmentDetails, { ...newporequirment }]);
    setNewporequirment({
        segment: '',
        identifier: '',
        value: '',
    });
};

const handleNewValueChange = (e) => {
    setNewporequirment({
        ...newporequirment,
        value: e.target.value,
    });
};

const handleNewValueChange1 = (e) => {
    setNewporequirment({
        ...newporequirment,
        identifier : e,
    });
};

const handleNewValueChange2 = (e) => {
    setNewporequirment({
        ...newporequirment,
        segment: e,
    });
    if(e.value == 'from mail'){
        setidentifierNames(id1)
    }else if(e.value == 'subject'){
        setidentifierNames(id2)
    }else{
        setidentifierNames(id3)
    }
};

  // Handle the change event for the Select component
  const handleSelectChange = (event, { value }) => {
    setSelectedSource(event);
  };

  const fetchsheetdata = (process) => {
    let payload = {
      File_data: process,
    }

    var FileUploadCredentials = SheetData1();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let table_data = response.data;
          console.log(table_data);
          let table_data_val = table_data;
          let names = [{ value: "", label: "Select Source" },]
          table_data.map((data) => {
            console.log('data' + data.source_name);

            let obj = {
              value: data.source_id,
              label: data.source_name
            }
            names.push(obj);
          })
          setSelectedOptions(names);
        }
      )
  };

  const handleSelectChange1 = (event, { value }) => {
    setProcess(event);
    fetchsheetdata(event)
  };

  const handleSelectChange2 = (event, { value }) => {
    setRelationshipType(event);
    console.log('value', event)
    if(event.value == 'read'){
        setShow(false)
        setShow1(true)
    }else if(event.value == 'send'){
        setShow(true)
        setShow1(false)
    }else{
        setShow(false)
        setShow1(false)
    }
  };

  const saveRelationship = () =>{
    
    let payload = {
        'relationship_name': relationshipName,
        'relationship_description': description,
        'process': process,
        'relationship_type': relationshipType,
        'sources': selectedSource
        
    }
    console.log('payload', payload)
    var FileUploadCredentials = SaveRelationship();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
          });
  }

  const fetchuserslist = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["selectedentity"],
        
    }

    var FileUploadCredentials = Fetchusersdata();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response users list!!!", response);
                let table_data1 = response.data;
                let table_data = table_data1.data_out;
                let names = [];
                table_data1.map((data) => {

                    let obj = {
                        value: data.user_id,
                        label: data.name
                    }
                    names.push(obj);
                })
                setSelectedOptions(names);
            }
        )
}

  const fetchProcessNames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetProcessNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.process_id,
                        label: data.process_name
                    }
                    names.push(obj);
                })
                setSelectedprocess1(names);
            }
        )
}

useEffect(() => {
    fetchuserslist();
  fetchProcessNames();
},[]);
  return (
    <>
      
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row >
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Name</label> <br />
              <div>
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  placeholder="name"
                  value={relationshipName}
                  onChange={(e) => setRelationshipName(e.target.value)}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Description</label> <br />
              <div >
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`processInput`}>Process</label> <br />
              <div >
                <Select
                  clearable
                  options={selectedprocess1}
                  selection
                  className="resource_input"
                  size='mini'
                  value={process}
                  onChange={handleSelectChange1}

                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Purpose</label> <br />
              <Select
                clearable
                options={identifier1}
                selection
                className="resource_input"
                size='mini'
                value={relationshipType}
                onChange={handleSelectChange2}
              />
            </div>
          </Grid.Column>
        

        </Grid.Row>

      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <Grid.Row >
      <Grid.Column>
        <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Mail box</label> <br />
              <div >
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  
                  value={description1}
                  onChange={(e) => setDescription1(e.target.value)}
                />
              </div>
            </div>
        </Grid.Column>
      <Grid.Column>
      <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Password</label> <br />
              <div >
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  
                  value={description2}
                  onChange={(e) => setDescription2(e.target.value)}
                />
              </div>
            </div>
      </Grid.Column>
        <Grid.Column>
          <div className="form-group">
            <label className="label1 mb-1" htmlFor={`sourceInput`}>Owners</label> <br />
            <Select
              clearable
              options={targetNames}
              selection
              className="resource_input"
              size='mini'
              value={selectedSource}
              onChange={handleSelectChange}
             
            />
          </div>
          </Grid.Column>
          
          </Grid.Row>
      </Grid>
      
      <Grid columns='equal' divided hidden={show} style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      {porequirmentDetails?.map((cost, i) => (
        <Grid.Row key={i}>
        <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" >Segment</label> <br />
                <Select
                  clearable
                  options={identifier2}
                  selection
                //   className="resource_input"
                  size='mini'
                  value={cost.segment}
                  onChange={(e) => handleMaterialNameQuotationChange2(e, i)}
                />
              </div>
        </Grid.Column>
        <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" >Identifier</label> <br />
                <Select
                  clearable
                  options={identifierNames}
                  selection
                //   className="resource_input"
                  size='mini'
                  value={cost.identifier}
                  onChange={(e) => handleMaterialNameQuotationChange1(e, i)}
                />
              </div>
        </Grid.Column>
        <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" >Value</label> <br />
                <div >
                  <Input
                    type="text"
                    className="resource_input"
                    style={{ width: '12em' }}
                    
                    value={cost.value}
                    onChange={(e) => handleMaterialNameQuotationChange(e, i)}
                  />
                </div>
              </div>
        </Grid.Column>
        </Grid.Row>
      ))}


      <Grid.Row >
      <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Segment</label> <br />
              <Select
                clearable
                options={identifier2}
                selection
                // className="resource_input"
                size='mini'
                value={newporequirment.segment}
                onChange={handleNewValueChange2}
              />
            </div>
      </Grid.Column>
      <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Identifier</label> <br />
              <Select
                clearable
                options={identifierNames}
                selection
                // className="resource_input"
                size='mini'
                value={newporequirment.identifier}
                onChange={handleNewValueChange1}
              />
            </div>
      </Grid.Column>
      <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Value</label> <br />
              <div >
                <Input
                  type="text"
                className="resource_input"
                  style={{ width: '12em' }}
                  name="value"
                  value={newporequirment.value}
                  onChange={handleNewValueChange}
                />
              </div>
            </div>
      </Grid.Column>
      <Grid.Column><button
            className="btn btn-raised btn-sm btn-outline-info ml-2"
            onClick={addFieldValue}
            style={{marginTop: '1.5em'}}
        >
            <i className="fa fa-plus"></i>
        </button></Grid.Column>
      </Grid.Row>
     
      </Grid>

      <Grid columns='equal' divided hidden={show1} style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      {porequirmentDetails?.map((cost, i) => (
        <Grid.Row key={i}>
        <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" >Segment</label> <br />
                <Select
                  clearable
                  options={identifier1}
                  selection
                //   className="resource_input"
                  size='mini'
                  value={cost.segment}
                  onChange={(e) => handleMaterialNameQuotationChange2(e, i)}
                />
              </div>
        </Grid.Column>
        <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" >Identifier</label> <br />
                <Select
                  clearable
                  options={identifierNames}
                  selection
                //   className="resource_input"
                  size='mini'
                  value={cost.identifier}
                  onChange={(e) => handleMaterialNameQuotationChange1(e, i)}
                />
              </div>
        </Grid.Column>
        <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" >Value</label> <br />
                <div >
                  <Input
                    type="text"
                    className="resource_input"
                    style={{ width: '12em' }}
                    
                    value={cost.value}
                    onChange={(e) => handleMaterialNameQuotationChange(e, i)}
                  />
                </div>
              </div>
        </Grid.Column>
        </Grid.Row>
      ))}


      <Grid.Row >
      <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Segment</label> <br />
              <Select
                clearable
                options={identifier1}
                selection
                // className="resource_input"
                size='mini'
                value={newporequirment.segment}
                onChange={handleNewValueChange2}
              />
            </div>
      </Grid.Column>
      <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Identifier</label> <br />
              <Select
                clearable
                options={identifierNames}
                selection
                // className="resource_input"
                size='mini'
                value={newporequirment.identifier}
                onChange={handleNewValueChange1}
              />
            </div>
      </Grid.Column>
      <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Value</label> <br />
              <div >
                <Input
                  type="text"
                className="resource_input"
                  style={{ width: '12em' }}
                  name="value"
                  value={newporequirment.value}
                  onChange={handleNewValueChange}
                />
              </div>
            </div>
      </Grid.Column>
      <Grid.Column><button
            className="btn btn-raised btn-sm ml-2"
            onClick={addFieldValue}
            style={{marginTop: '1.5em', backgroundColor:'#fff'}}
        >
            <i className="fa fa-plus">+</i>
        </button></Grid.Column>
      </Grid.Row>
      </Grid>
      
    </>
  )
}

export default NewMail;